
  <div class="min-h-screen flex items-center justify-center">
   <div class="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
    <div class="text-center mb-6">
     <h2 class="text-3xl font-bold text-purple-700">
      Welcome Back!
     </h2>
     <p class="text-gray-600 text-sm mt-3">
      Please choose your login type
     </p>
    </div>
    <div class="flex flex-col space-y-4">
     <a class="w-full text-center py-3 px-4 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition duration-300 flex items-center justify-center" href="/dashboardlogin">
      <i class="fas fa-user-shield mr-2">
      </i>
      Login as Admin
     </a>
     <a class="w-full text-center py-3 px-4 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition duration-300 flex items-center justify-center" href="/login">
      <i class="fas fa-user mr-2">
      </i>
      Login as User
     </a>
    </div>
    <div class="mt-6 text-center">
     
    </div>
   </div>
  </div>

